import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import {
    SPONSORSHIP_BONUS_AMOUNT,
    SPONSORSHIP_BONUS_PERCENT,
    SPONSORSHIP_PURCHASE_THRESHOLD,
    SPONSORSHIP_IS_BOOSTED_OPERATION,
    SPONSORSHIP_BOOSTED_OPERATION_END_DATE,
    SPONSORSHIP_BOOSTED_BONUS_AMOUNT
} from '../../../constants/sponsorship';
import { STATIC_ROOT } from '../../../constants';

import { toMoment, nowTimestamp } from '../../../utils/dateUtils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import SvgComponent from '../../SvgComponent';

import './SponsorshipHowItWorks.scss';

export class SponsorshipHowItWorks extends React.Component {
    render() {
        const { i18n } = this.props;

        const cashbackAmountForExample = 20;

        const isBoostedOperationActive =
            SPONSORSHIP_IS_BOOSTED_OPERATION &&
            SPONSORSHIP_BOOSTED_OPERATION_END_DATE &&
            toMoment(nowTimestamp()).isBefore(moment(SPONSORSHIP_BOOSTED_OPERATION_END_DATE));

        const bonusDisplayed = isBoostedOperationActive
            ? SPONSORSHIP_BOOSTED_BONUS_AMOUNT
            : SPONSORSHIP_BONUS_AMOUNT;

        return (
            <div>
                <h2>{i18n.HOW_IT_WORK_TITLE}</h2>
                <div className="how-it-work-wrapper">
                    <p>
                        {convertHtmlToReactDomWithParams(
                            i18n.HOW_IT_WORK_TEXT,
                            bonusDisplayed,
                            SPONSORSHIP_BONUS_PERCENT
                        )}
                    </p>

                    <div className="steps">
                        <div>
                            <div className="step">
                                <p>{convertHtmlToReactDomWithParams(i18n.STEP1_TEXT)}</p>
                            </div>
                            <div className="step-icon">
                                <SvgComponent
                                    src={`${STATIC_ROOT}/sponsorship/bag.svg`}
                                    width="85"
                                    height="100"
                                />
                                <span className="step-amount bag">{i18n.STEP1_AMOUNT}</span>
                            </div>
                        </div>
                        <SvgComponent src={`${STATIC_ROOT}/fleche.svg`} width="20" height="35" />
                        <div>
                            <div className="step">
                                <p>
                                    {convertHtmlToReactDomWithParams(
                                        i18n.STEP2_TEXT,
                                        cashbackAmountForExample,
                                        bonusDisplayed
                                    )}
                                </p>
                            </div>
                            <div className="step-icon">
                                <SvgComponent
                                    src={`${STATIC_ROOT}/sponsorship/purse.svg`}
                                    width="80"
                                    height="100"
                                />
                                <span className="step-amount purse">
                                    {convertHtmlToReactDomWithParams(
                                        i18n.STEP2_AMOUNT,
                                        cashbackAmountForExample + bonusDisplayed
                                    )}
                                </span>
                            </div>
                        </div>
                        <SvgComponent src={`${STATIC_ROOT}/fleche.svg`} width="20" height="35" />
                        <div>
                            <div className="step green">
                                <p>
                                    {convertHtmlToReactDomWithParams(
                                        i18n.STEP3_TEXT,
                                        bonusDisplayed +
                                            cashbackAmountForExample *
                                                (SPONSORSHIP_BONUS_PERCENT / 100),
                                        bonusDisplayed,
                                        SPONSORSHIP_BONUS_PERCENT,
                                        cashbackAmountForExample
                                    )}
                                </p>
                            </div>
                            <div className="step-icon green">
                                <SvgComponent
                                    src={`${STATIC_ROOT}/sponsorship/purse.svg`}
                                    width="80"
                                    height="100"
                                />
                                <span className="step-amount purse">
                                    {convertHtmlToReactDomWithParams(
                                        i18n.STEP3_AMOUNT,
                                        bonusDisplayed +
                                            cashbackAmountForExample *
                                                (SPONSORSHIP_BONUS_PERCENT / 100)
                                    )}
                                </span>
                            </div>
                        </div>
                    </div>

                    <p className="mention">
                        {convertHtmlToReactDomWithParams(
                            i18n.MENTION_TEXT,
                            bonusDisplayed,
                            SPONSORSHIP_PURCHASE_THRESHOLD,
                            SPONSORSHIP_BONUS_PERCENT
                        )}
                    </p>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.SPONSORSHIP
    };
};

export default connect(mapStateToProps)(SponsorshipHowItWorks);



// WEBPACK FOOTER //
// ./src/components/pages/sponsorship/SponsorshipHowItWorks.js